import { Tenant } from 'application/Shared/types/tenant';

/**
 * Checks if a tenant has support access enabled.
 * By default, support access is enabled and there is no setting specified in the database.
 * So, we need to check if the setting is explicitly set to false.
 * @param tenant - The tenant to check.
 * @returns True if the tenant has support access enabled, false otherwise.
 */
export const tenantHasSupportAccess = (tenant?: Tenant) =>
    tenant?.settings?.enableAuvikSupportAccess !== false;
